import { render, staticRenderFns } from "./MultipleChoiceAnswer.vue?vue&type=template&id=ebe55c8e&scoped=true&"
import script from "./MultipleChoiceAnswer.vue?vue&type=script&lang=ts&"
export * from "./MultipleChoiceAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./MultipleChoiceAnswer.vue?vue&type=style&index=0&id=ebe55c8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe55c8e",
  null
  
)

export default component.exports